import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import { store } from "store";
import axios from "axios";
var ChooseEventView = /** @class */ (function (_super) {
    tslib_1.__extends(ChooseEventView, _super);
    function ChooseEventView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = store;
        _this.currentOrganizationEvents = null;
        return _this;
    }
    ChooseEventView.prototype.routed = function () {
        this.currentOrganizationEvents = store.events
            .filter(function (e) { return e.organizationId == store.selectedOrganization.organizationId; });
        store.page.title = this.$t("chooseEventView.title");
        store.page.showTopNav = true;
    };
    ChooseEventView.prototype.eventDateDisplay = function (e) {
        if (e.eventDate)
            return this.$d(new Date(e.eventDate));
        return "";
    };
    ChooseEventView.prototype.chooseEvent = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        store.currentUser.selectedEventId = event.eventId;
                        if (!store.currentUser.selectedOrganizationId)
                            store.currentUser.selectedOrganizationId = event.organizationId;
                        return [4 /*yield*/, axios.put("users/" + store.currentUser.userId, store.currentUser)];
                    case 1:
                        _a.sent();
                        store.selectedEvent = event;
                        this.$router.push('/');
                        return [2 /*return*/];
                }
            });
        });
    };
    ChooseEventView = tslib_1.__decorate([
        Component
    ], ChooseEventView);
    return ChooseEventView;
}(Vue));
export default ChooseEventView;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/views/ChooseEventView.vue
// module id = 57
// module chunks = 0